import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Endpoints } from "src/app/shared/config/endpoints";
import { GeneralService } from "../general.service";
import { OrgModel } from "./../../store/storeModels/user.model";

@Injectable({
  providedIn: "root",
})
export class UserRolesService {
  private signupUrl = this.config.signUpEndpoint;
  private org: OrgModel;
  constructor(
    private http: HttpClient,
    private config: Endpoints,
    private gs: GeneralService
  ) {
    this.org = this.gs.org;
  }

  // INVITE =>  POST: This service invites a user
  inviteUser(payload) {
    const body = { ...payload, orgID: this.org.id };
    return this.http.post<any>(this.signupUrl + "/inviteUser", body);
  }

  reInviteUser(userId: number) {
    const url = `${this.signupUrl}/reinvite_user/${userId}/${this.org.id}`;
    return this.http.get(url);
  }

  revokeInvitedUser(userId) {
    const url = `${this.signupUrl}/${userId}/${this.org.id}/revokeInvitedUser`;
    return this.http.delete(url);
  }

  changeUserOrganizationStatus(userId) {
    const body = {
      orgID: this.org.id,
      userID: userId,
    };
    const url = `${this.signupUrl}/changeUserOrganizationStatus/${userId}/${this.org.id}/`;
    return this.http.post(url, body);
  }

  editUser(payload) {
    const body = { ...payload };
    return this.http.post(this.signupUrl + "/editUser/", body);
  }

  getAdditionalUserValue(userNumber) {
    const headers = this.gs.getCommandCenterHeaders();
    const url = `${this.config.adminserviceUrl}/getCostForUsers/${this.org.id}/${userNumber}`;
    return this.http.get(url,{headers});
  }




  getAdditionalUserValueByBill(numberOfUsers, billingID) {
    const headers = this.gs.getCommandCenterHeaders();
    const url = `${this.config.adminserviceUrl}/getCostForUsersOnBilling/${this.org.id}/${numberOfUsers}/${billingID}`;
    return this.http.get(url,{headers});
  }


  editUserInAnOrganization(payload) {
    const body = {
      orgID: this.org.id,
      ...payload
    };
    return this.http.post(this.signupUrl + "/editUserSettings/", body);
  }

  getUsersByRoles(userId: number) {
    return this.http.get(this.signupUrl + "/reinvite_user/" + userId);
  }

  getOrganizationPersons(type: number) {
    const url = `${this.signupUrl}/getOrganizationPersons/${this.org.id}/${type}`;
    return this.http.get(url);
  }

  async getOrganizationPersonsDetails(type: number, recast: boolean) {
    try {
      let payload: any = await this.getOrganizationPersons(type).toPromise();

      // Recast payload
      if (recast === true) {
        let res = [];
        payload.filter((u) => {
          const item = {
            fullName: u["user"].firstName + " " + u["user"].lastName,
            ...u["user"],
            ...u["userRel"],
          };
          res.push(item);
        });
        return res;
      };
      return payload;
    } catch (error) {
    }
  }


  getAdditionalUserValueByAddOn(payload: any) {
    const headers = this.gs.getCommandCenterHeaders();
    const url = `${this.config.adminserviceUrl}/calculateAddOnUserCost`;
    return this.http.post(url, payload, {headers});
  }
}
